






















import {NodeData} from '@/system/nodes/interfaces';
import {Vue, Component, Prop} from 'vue-property-decorator';
@Component({})
export default class NodeLink extends Vue {
  @Prop({required: true})
  item!: NodeData;

  @Prop({required: false})
  route!: boolean;

  @Prop({type: String})
  tooltipStr!: string;

  @Prop({type: Boolean, default: false})
  showTooltip!: boolean;

  @Prop({type: String, default: ''})
  background!: string;

  @Prop({type: String, default: ''})
  color!: string;

  onClick(evt: MouseEvent) {
    this.$emit('click', this.item);
    if (this.route) {
      this.$router.push({
        name: 'NodeView',
        params: {id: `${this.item.id}`},
      });
    }
    evt.stopPropagation();
  }
}
